<template>
  <main>
    <cms-section v-if="eSpots?.[0]?.items" :section="eSpots[0]" />
    <loyalty-programme-tiering :heading="tiering.heading" :image="tiering.image" :tiers="tiering.tiers" />
    <cms-section v-if="eSpots?.[1]?.items" :section="eSpots[1]" />
    <loyalty-programme-sign-in
      v-if="!auth.loggedIn"
      :content="signIn"
    />
    <cms-section v-if="eSpots?.[2]?.items" :section="eSpots[2]" />
  </main>
</template>

<script lang="ts" setup>
const { supportedLocales } = useAppConfig().pages.loyaltyProgramme
const { $locale } = useNuxtApp()

if (!supportedLocales.includes($locale))
  throw createError({ message: `Page is not available for ${$locale} locale`, statusCode: 404, fatal: true })

const { data, error } = await useApi().internal.getStaticPage('loyalty-programme/loyalty-programme')
if (!data.value) throw createError({ ...error.value!, fatal: true })
const { signIn, tiering } = data.value

definePageMeta({
  header: { transparent: true },
  middleware() {
    if (useAuthStore().loggedIn) return navigateTo('/account/loyalty', { replace: true })
  }
})

const auth = useAuthStore()
const eSpots = (await useCms().getSections.generic('loyalty-programme')).data.value?.content.sections
</script>
